import { h, Component } from 'preact';
import s from 'components/bolt/dualMenu/dualMenu.sss';
import Store from 'store/store';
import { joinClasses, accessNested, sortObjectByOrder } from 'utils/utils';

export default class DualMenu extends Component {
	renderButton(type, active, text) {
		return (
			<button
				class={joinClasses(s.button, active && s.active, 'mediumB')}
				onClick={() => Store.emit('SWITCH_DUAL_VIEW', type, this.props.isWidget)}
				key={type}
			>
				<span>{text}</span>
			</button>
		);
	}

	render(props) {
		const store = Store.get();
		const copy = accessNested(store, 'appData.copy.baseCopy', {});

		const showtimesCopy = props.widgetData?.dualMenuShowtimesCopy || copy.$DUAL_VIEW_SHOWTIMES_BTN;
		const homeEntCopy = props.widgetData?.dualMenuHomeEntCopy || copy.$DUAL_VIEW_HOMEENT_BTN;

		let elements = sortObjectByOrder([
			{
				order: store.appData.pages.boltShowtimes?.order,
				component: this.renderButton('showtimes', store.activePage === 'boltShowtimes' || props.isWidget === 'showtimes', showtimesCopy || 'Watch in cinemas')
			},
			{
				order: store.appData.pages.boltHomeEnt?.order,
				component: this.renderButton('homeent', store.activePage === 'boltHomeEnt' || props.isWidget === 'homeEnt', homeEntCopy || 'Watch at home')
			},
		], value => value.component);

		return (
			<div class={joinClasses(s.wrapper, props.isWidget && s.widget)}>
				{elements}
			</div>
		);
	}
}
